import { APSThemes } from './aps';
import { ThemeType } from './types';

export const Themes: Array<ThemeType> = [...APSThemes];
